import { Typography } from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';
import { useEffect, useMemo } from 'react';
import { Button, createDateField, createSelectField, createTextField } from '@roc/ui';
import Grid from '@material-ui/core/Grid';
import { idTypeOptions } from '@roc/feature-loans';
import { NO, YES, borrowerStatesAbbreviation, borrowerStatesNames } from '@roc/feature-utils';
import { observer } from 'mobx-react';
import { format, isValid } from 'date-fns';

const stateOptions = borrowerStatesAbbreviation.map((abbreviation, i) => ({
  value: abbreviation,
  label: borrowerStatesNames[i],
}));

export const IdInformation = observer(({ store }) => {

  const { idInformationStore } = store;

  const showPassportFields = useMemo(() => {
    return idInformationStore.form.fields.idType.value !== 'US Driver\'s License / Government ID';
  }, [idInformationStore.form.fields.idType.value]);

  useEffect(() => {
    idInformationStore.onFieldChange('driversLicense', showPassportFields ? NO : YES);
  }, [showPassportFields]);

  const manageDate = (fieldName, date) => {
    let formattedDate = null;
    if (isValid(date)) {
      formattedDate = format(date, 'MM/dd/yyyy');
    }
    idInformationStore.onFieldChange(fieldName, formattedDate);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5">Identification</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        {createSelectField({
          store: idInformationStore,
          testId: 'idType',
          fieldName: 'idType',
          label: 'ID Type',
          options: idTypeOptions,
          placeholder: 'Make Selection',
        })}
      </Grid>
      {showPassportFields ? (
        <>
          <Grid item xs={12} sm={3}>
            {createTextField({
              store: idInformationStore,
              testId: 'passportNumber',
              fieldName: 'passportNumber',
              label: 'Passport Number',
            })}
          </Grid>
          <Grid item xs={12} sm={3}>
            {createDateField({
              store: idInformationStore,
              label: 'Passport Expiration',
              fieldName: 'passportExpiration',
              testId: 'passportExpiration',
              format: 'MM/dd/yyyy',
              onChange: manageDate,
            })}
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={12} sm={3}>
            {createSelectField({
              store: idInformationStore,
              testId: 'driversLicenseState',
              fieldName: 'driversLicenseState',
              label: "Driver's License State",
              options: stateOptions,
            })}
          </Grid>
          <Grid item xs={12} sm={3}>
            {createTextField({
              store: idInformationStore,
              testId: 'driversLicenseNumber',
              fieldName: 'driversLicenseNumber',
              label: "Driver's License Number",
            })}
          </Grid>
        </>
      )}
      {store.borrowerDetailsVerification?.isDriverLicenseFileUploaded && (
        <Grid item xs={12}>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<CloudDownload />}
            onClick={() => store.getIdFile()}
            testId="downloadIdFile"
          >
            Download ID
          </Button>
        </Grid>
      )}
    </Grid>
  )
});
